import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.setDefaultPODisclaimer.presenters.useSetDefaultPODisclaimerPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  savedAsDefault: {
    id: `${scope}.savedAsDefault`,
    defaultMessage: '{description} saved as default',
  },
  removedAsDefault: {
    id: `${scope}.removedAsDefault`,
    defaultMessage: '{description} removed as default',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to update the default label.',
  },
})
